<template>
  <v-container fluid>
    <!-- <v-breadcrumbs :items="items">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs> -->
    <div id="app ">
      <v-row>
        <v-col cols="11">
          <Breadcrumb
            class="row justify-content-center mt-4"
          />
        </v-col>
        <v-col cols="1" v-if="showLoader">
          <LoaderProgress></LoaderProgress>
        </v-col>
      </v-row>
    </div>
    <v-row>
      <v-col>
        <!-- <filterHeaderComp /> -->
        <newFiltercomp style="margin-right: 5px !important" :filter_data="param" />
      </v-col>
    </v-row>
    <!-- <v-data-table
      ref="theDataTable"
      :headers="headersData"
      :items="operatorsData"
      :search="search"
      :custom-sort="this.DateSort"
      :items-per-page="5"
      class="elevation-1"
      @pagination="pagination = $event"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>

          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="50"
            offset-x
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class=""
                outlined
                fab
                small
                color="#0C479D"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>icon-download</v-icon>
              </v-btn>
            </template>

            <v-card>
              

              <v-divider></v-divider>

              <v-list>
                <v-list-item>
                  <v-list-item-action>
                    <vue-json-to-csv
                      :json-data="dataDownload"
                      :csv-title="'Energy Consumption Report Data'"
                    >
                      <v-btn color="indigo" dark style="">
                        CSV
                      </v-btn>
                    </vue-json-to-csv>

                  </v-list-item-action>
                </v-list-item>

                <v-list-item>
                  <v-list-item-action>
                    <v-btn @click="createPDF" color="indigo" dark>PDF </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
        </v-toolbar>
      </template>

    </v-data-table> -->
    <div>
      <tableComponent v-bind:tabledataProp="TableData" v-if="show_table"/>
    </div>
  </v-container>
</template>
<script>

// import filterHeaderComp from "../components/filterHeaderComp.vue";
import tableComponent from '../components/tableComponent.vue';

import Breadcrumb from "../components/breadcrumbs.vue";
import LoaderProgress from "../components/progressLoader";
import newFiltercomp from "../components/newFiltercomp.vue";
import axios from "axios";
// import constants from "../constants";
import router from "../router";
import "jspdf-autotable";
// const logo = require("../assets/trinitiimage.png");
export default {
  components: {
    newFiltercomp,
    //  filterHeaderComp
    Breadcrumb,
    LoaderProgress,
    tableComponent,
  },

  data() {
 
    return {
      show_table:false,
      TableData:{
      search:'',
      savingFilename:'Energy Consumption Report',
      columnHeaders 
      :[
      "Machine Name",        
        "Energy Consumption Time",
        "Total Power(kWh)",
        "Total Price"
        
      ],
      pagination: {
        page: null,
        itemsPerPage: null,
        pageStart: null,
        pageStop: null,
        pageCount: null,
        itemsLength: null,
      },
      tempRow :[
      "machine_name",
            "perform_date",
            "total_kWh" ,
            "total_price" 
          ]
      

      },
      crumbs: ["Home", "Report Menu", "Energy Consumption Report"],


      items: [
        {
          text: "Home",
          disabled: false,
          href: "/",
        },
        {
          text: "Report Menu",
          disabled: true,
          href: "/",
        },
        {
          text: "Energy Consumption Report",
          disabled: true,
        },
      ],
         param : {
        machine : true,
        time_period: true,
        check : false,
        aggfunc : false,
        date : false,
        date_2 : false,
        time: false,
        time2: false,
        select_1: 1,

        // select_1:'1 Hour'
      },
    filter_data: [],
      showWarning: false,
      showLoader: false,
      dataDownload: [],
      search: "",
      operatorsData: [],
      menu: false,
      headersData: [],
      pagination: {
        page: null,
        itemsPerPage: null,
        pageStart: null,
        pageStop: null,
        pageCount: null,
        itemsLength: null,
      },
    };
  },

  mounted() {},

  methods: {
    DateSort: function(items, index, isDesc) {
      if (index[0] == "perform_date") {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return new Date(b[index]) - new Date(a[index]);
          } else {
            return new Date(a[index]) - new Date(b[index]);
          }
        });
      } else if (
        index[0] != "perform_date" 
      ) {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            if (typeof a[index] == "number" ) {
                return b[index] - a[index];
            }
            else
            {
            console.log("checking incase not perform", a[index], b[index]);

            }
          } else {
             if (typeof a[index] == "number" ) {
                return a[index] - b[index];
            }
            else{
            console.log("checking incase not perform", a[index], b[index]);

            }
          }
        });
      }

      return items;
    },


    selected(crumb) {
      if (crumb === "Home") {
        router.push(`/${sessionStorage.getItem("route_first_option")}`);
      }

      console.log(crumb);
    },
    // createPDF() {
    //   let content = this.$refs["theDataTable"];
    //   console.log("pagination", this.pagination);
    //   let doc = new jsPDF("latitude");
    //   doc.text(14, 7.5, "Energy Consumption Report");
    //    doc.addImage(
    //     this.getImgUrl1(this.$config.image_inside_pdf),
    //     "png",
    //     this.$config.first_dimension_separate_again,
    //     this.$config.second_dimension_separate,
    //     this.$config.third_dimension_separate,
    //     this.$config.fourth_dimension_separate_again
    //   );
    //   let columnHeaders = [
    //     "Machine Name",        
    //     "Energy Consumption Time",
    //     "Total Power(kWh)",
    //     "Total Price"
    //   ];
    //   let rows = [];
    //   content.items.forEach((data, index) => {
    //     if (
    //       index >= this.pagination.pageStart &&
    //       index < this.pagination.pageStop
    //     ) {
    //       let tempRow = [
    //         data.machine_name || "",
    //         data.perform_date || "",
    //         data.total_kWh || "",
    //         data.total_price || "",
    //       ];
    //       rows.push(tempRow);
    //     }
    //   });
    //   console.log("checkign temp row=>", rows);
    //   doc.setFontSize(9);
    //   doc.autoTable(columnHeaders, rows, { startY: 11.5 });
    //   let d = new Date();
    //   doc.save(
    //     `Energy_Consumption_Report ${d.toISOString().slice(0, 10) +
    //       " " +
    //       d
    //         .toTimeString()
    //         .split("(")[0]
    //         .slice(0, -1)}.pdf`
    //   );
    // },

    intervalFetchData: function(
      machine_id,
      startDate,
      endDate,
      show,
      grp_show,
      check
    ) {
      this.machine_id_Selected = machine_id;
      this.start_date = startDate;
      this.end_date = endDate;
      console.log("machine id", machine_id);
      console.log(
        "selected start date",
        startDate,
        "selected end date",
        startDate
      );

      this.searchNew(
        this.machine_id_Selected,
        startDate,
        endDate,
        show,
        grp_show,
        check
      );
    },
    searchNew: function(machine_id, startDate, endDate, show, grp_show, check) {
      this.start_date = startDate;
      this.end_date = endDate;
      this.machine_id_Selected = machine_id;
      this.show_table=false

      console.log(
        "machine select",
        this.machine_id_Selected,
        "Done to say",
        machine_id,
        check
      );
      let params = "";
      if (this.start_date == "") {
        params = `?machine_id=${machine_id}`;
      } else {
        params = `?machine_id=${machine_id}&startdate=${this.start_date}&enddate=${this.end_date}&agg_function=${show}&timeframe=${grp_show}`;
      }
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getEnergyConsumptionData${params}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.setGridData(config);
    },
    setGridData: function(config) {
      this.headersData = [
        {
          text: "Machine Name",
          value: "machine_name",
          sortable: true,
        },

        {
          text: "Energy Consumption Time",
          value: "perform_date",
          sortable: true,
        },

        {
          text: "Total Power(kWh)",
          value: "total_kWh",
          sortable: true,
        },

        {
          text: "Total Price",
          value: "total_price",
          sortable: true,
        },
      ];
      this.TableData['headersData']=this.headersData

      this.showLoader = true;
      this.showWarning = false;
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          let _data = response.data.data;
          console.log("checking report");
          console.log("checkign resp", response.data.data);
          this.operatorsData = response.data.data;
          this.TableData['operatorsData']=this.operatorsData

          console.log("thisisdata", this.operatorsData);
          let result = [];
          for (let i in response.data) result.push([i, response.data[i]]);
          this.dataDownload = result[0][1];
          this.TableData['dataDownload']=this.dataDownload
          this.show_table= true

          this.item = _data;
          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            this.showWarning = true;
            this.item = [];
            console.log("axios error", error.message);
          }
        });
    },
  },
};
</script>
<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
